import { updateDocumentHelpers } from 'global/firestoreData/updates/subUpdates/fsUpdate_document';
import { useCallback, useContext, useState } from 'react';
import { ParentContext } from '../ParentContext';

export const useDocuments = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}

  const [updating, setUpdating] = useState()

  const delete_itemInDocuments = useCallback(({ documentCollection, selectedItems }) => {
    updateDocumentHelpers.delete_itemInDocuments(database_fns, documentCollection, selectedItems, pathViews)
  }, []);

  const get_allDocuments = useCallback(({ callback }) => {
    updateDocumentHelpers.get_allDocuments(database_fns, pathViews, callback)
  }, []);

  const update_allDocuments = useCallback(({ documentsData }) => {
    updateDocumentHelpers.update_allDocuments(database_fns, pathViews, documentsData)
  }, []);

  const update_dataToDocument = useCallback(({ collection_pk, data, dataRestrictions, dispatch }) => {
    updateDocumentHelpers.update_dataToDocument(database_fns, pathViews, collection_pk, data, dataRestrictions, dispatch)
  }, []);

  const update_dataToDocuments = useCallback(({ dataCollections, dispatch }) => {
    updateDocumentHelpers.update_dataToDocuments(database_fns, pathViews, dataCollections, dispatch)
  }, []);

  const update_itemInDocuments = useCallback(({ batch, documentName, documentKey, itemData, callback, allowUpdate }) => {
    updateDocumentHelpers.update_itemInDocuments(batch, mainDb, database_fns, pathViews, documentName, documentKey, itemData, callback, allowUpdate)
  }, []);

  const update_itemsInDocument = useCallback(({ documentName, data, allowUpdate }) => {
    updateDocumentHelpers.update_itemsInDocument(database_fns, pathViews, documentName, data, allowUpdate)
  }, []);

  return {
    updating,
    delete_itemInDocuments,
    get_allDocuments,
    update_allDocuments,
    update_allDocuments,
    update_dataToDocument,
    update_dataToDocuments,
    update_itemInDocuments,
    update_itemsInDocument,
  }
}
